module.exports = __webpack_public_path__ + "static/media/English_US_Brandon BG-49.e57eab94.png";